import styled from 'styled-components';
import { Menu, Button } from 'antd';
import { PushpinOutlined } from '@ant-design/icons';

export const TableWrapper = styled.div`
  min-height: 500px;
  height: 100%;
  position: relative;

  .BaseTable__row-cell {
    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const ViewerSessionsTableHeader = styled.div`
  height: 50px;
  line-height: 50px;
  position: relative;

  &:first-child .BaseTable__header-cell-text {
    padding-left: 7.5px;
  }

  .BaseTable__header-cell {
    padding-right: 16px;
    padding-left: 8px !important;
  }

  .BaseTable__header-cell-text {
    white-space: nowrap;
  }

  .BaseTable__sort-indicator {
    margin-right: 3px;
  }
`;

export const Styled_ViewerTableTitle = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  gap: 4px;
  width: 100%;
`;

export const HeaderActions = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
  gap: 2px;
`;

export const SortButton = styled.span<{ $active?: boolean }>`
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  line-height: 0;
  margin-left: 2px;
  flex-shrink: 0;

  .anticon {
    font-size: 10px;
    color: #bfbfbf;
    vertical-align: 0;
  }
`;

export const Styled_IconWrapper = styled.span`
  padding: 10px;

  .anticon {
    vertical-align: 0;
  }
`;

export const FooterWrapper = styled.div`
  text-align: center;
  font-size: 1em;
  font-weight: 600;
`;

export const LoadMoreFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
  color: #1890ff;
  font-size: 13px;
  font-weight: 500;
  gap: 6px;

  &:hover {
    color: #40a9ff;
  }
`;

export const KebabIcon = styled.span`
  height: fit-content;
  font-size: initial;
`;

export const AnchorIcon = styled(PushpinOutlined)`
  position: absolute;
  right: 4px;
  top: 10px;
  color: #000;
`;

export const ItemContent = styled.span`
  margin-right: 14px;
`;

export const MetricMenu = styled(Menu)`
  overflow: scroll;
  max-height: 300px;

  .li {
    margin-top: 0;
    margin-bottom: 0 !important;
  }

  .ant-menu-item-selected {
    background-color: unset !important;
    color: unset;
  }
`;

export const StyledButton = styled(Button)`
  margin-bottom: 10px;
`;

export const DataTriggerBoxWrapper = styled.div`
  padding: 10px 0;
`;

export const DataTableWrapper = styled.div`
  height: calc(100% - 55px);
`;

export const DataTriggerBox = styled.div<{ $pushRight?: boolean }>`
  white-space: nowrap;
  text-align: right;
  ${({ $pushRight }) =>
    $pushRight &&
    `
    position: relative;
    left: 10px;
  `}
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const StyledSearch = styled.span<{ $active?: boolean }>`
  cursor: pointer;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 0 4px;

  .anticon {
    font-size: 12px;
    color: ${({ $active }) => ($active ? '#1890ff' : '#bfbfbf')};
    vertical-align: 0;

    &:hover {
      color: #1890ff;
    }
  }
`;

export const SearchDropdown = styled.div`
  width: 300px;
  padding: 8px;

  .ant-input-affix-wrapper {
    border-radius: 4px;
  }
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  .ant-select {
    flex: 0 0 auto;
    min-width: 110px;
  }

  .ant-input-affix-wrapper,
  .ant-input {
    flex: 1 1 auto;
    min-width: 0;
  }
`;
